import React, { useContext, useState, useEffect } from "react";
import SingleBar from "charts/SingleBar";
import { DataContext } from "App";
import { getHourNum } from "utils/index";

const map = {
  "0": "PC",
  "1": "MOB",
  "2": "OTT",
};

const Platform: React.FC = () => {
  const appData = useContext(DataContext);
  const [hourData, setHourData] = useState<{ name: string; value: number }[]>(
    []
  );

  useEffect(() => {
    let Timer: NodeJS.Timeout;

    function setData() {
      setHourData(
        (appData?.dimension?.plt as {
          name: "0" | "1" | "2";
          value: number;
        }[])?.map(({ name, value }) => ({
          name: map[name],
          value: getHourNum(value, appData?.percent),
        }))
      );
      Timer = setTimeout(() => setData(), 30000);
    }

    setData();

    return () => {
      clearTimeout(Timer);
    };
  }, [appData]);

  return <SingleBar data={hourData} />;
};

export default Platform;
